import React, { ReactNode } from 'react';

import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Typography } from '@mui/material';
import { IconButton } from 'components/IconButton';

import { downloadFileByUrl } from '@common/helpers/downloadFile';

import { StyledLessonsLinkItemWrap } from './styled';

interface PropsType {
	title: ReactNode;
	href: string;
	download?: string;
	isCommonLink?: boolean;
}

function LessonsLinkItem({ title, href, download, isCommonLink = false }: PropsType) {
	const isViewableInBrowser =
		/\.(pdf|jpg|jpeg|png|gif|svg|webp)$/i.test(href) ||
		/^(https?:\/\/)(www\.)?(zoom\.us|miro\.com)/i.test(href);

	const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
		if (isViewableInBrowser) {
			window.open(href, '_blank', 'noopener,noreferrer');
		} else {
			event.preventDefault();
			try {
				await downloadFileByUrl(href, download);
			} catch (error) {
				console.error('Error downloading file:', error);
			}
		}
	};

	if (isCommonLink) {
		return (
			<StyledLessonsLinkItemWrap>
				<Typography component="div">{title}</Typography>
				<a href={href} rel="noreferrer" target="_blank">
					<IconButton variant="contained" color="info">
						<ArrowOutwardIcon sx={{ fontSize: '16px' }} />
					</IconButton>
				</a>
			</StyledLessonsLinkItemWrap>
		);
	}

	return (
		<StyledLessonsLinkItemWrap>
			<Typography component="div">{title}</Typography>
			<IconButton variant="contained" color="info" onClick={handleClick}>
				<ArrowOutwardIcon sx={{ fontSize: '16px' }} />
			</IconButton>
		</StyledLessonsLinkItemWrap>
	);
}

export default LessonsLinkItem;
